import { getCurrentUserDetail } from "../utils/currentUserDetail.js";
// import axios from "axios";
import axios from "../axios-interceptor.js"
import { encodeTerm } from "../utils/encodeDecode.js";

const BACKEND_API = process.env.REACT_APP_BACKEND_API;
let tenantId = localStorage.getItem("tenantId")

export const getUserInfo = async () => {
  let userInfo = getCurrentUserDetail();
  await axios({
    method: "GET",
    url: `${process.env.REACT_APP_BACKEND_API}/user?email=${userInfo.email}`,
    headers: {
      tenantId: tenantId
    }
  }).then(res => {
    localStorage.setItem("v_userInfo", JSON.stringify({ ...res.data?.result, email: userInfo.email }))
  })

}



export const getSpaceTemplates = async (spaceId, userInfo) => {
  let templatesList = []
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/template`,
      params: {
        spaceId: spaceId,
      },
      headers: {
        userId: userInfo.userId,
      },
    })
    if (response.data) {
      templatesList = response.data
    }
  }
  catch {

  }
  return templatesList
}

export const getUserInfoByEmail = async (email = '') => {
  let userEmail = email || localStorage.getItem("userEmail");
  let userDetail = {};
  try {
    let userReponse = await axios({
      method: "GET",
      url: `${BACKEND_API}/user`,
      headers: {
        tenantId: tenantId
      }
    })

    if (userReponse.status === 200 && userReponse?.data?.result) {
      userDetail = userReponse.data.result
      localStorage.setItem("userId", userDetail.userId)
    } else {
      // The backend answered, it just has no user for this email.
      userDetail.message = userReponse?.data?.message
      userDetail.userNotFound = true
    }
  }
  catch (error) {
    // Only a real response (e.g. 404) proves the user is missing; a network
    // failure must not be reported as "user not found".
    if (error?.response) {
      userDetail.message = error.response?.data?.message
      userDetail.userNotFound = true
    }
  }
  return userDetail
}

export const checkEmailExists = async (email) => {
  let exists = false;
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/email-exist/${email}`
    })
    exists = response?.data?.result || false
  }
  catch {

  }
  return exists
}

export const getFormDataForTemplateList = async (formIds, userInfo) => {
  
  let reqFormIds = formIds.join(",");

  let result = [];
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/formsByIds?formIds=${reqFormIds}`,
      headers: {
        userId: 1,
      },
    })
    result = response.data
  }
  catch {

  }
  return result;
}

export const getSpaceDefinedWidgets = async (spaceId, userInfo) => {
  let widgetList = [];
  
  // Validate spaceId before making API call
  if (!spaceId || spaceId === 'undefined' || spaceId === undefined) {
    return widgetList;
  }
  
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/definedWidgets/${spaceId}`,
      headers: {
        userId: userInfo.userId,
        tenantId: tenantId
      },
    })
    if (response && response.data && typeof response.data !== 'string') {
      widgetList = response.data
    }
  }
  catch {

  }
  return widgetList
}

export const searchUserByEmail = async (email, signal) => {
  let userList = [];
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/users/${encodeTerm(email)}`,
      signal: signal,
      headers: {
        tenantId: tenantId,
      },
    })
    if (response.status === 200) {
      userList = response?.data?.result || []
    }
  }
  catch {

  }
  return userList
}

export const searchGroupByName = async (name, signal) => {
  let groupList = [];
  
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/group/autocomplete/${encodeTerm(name)}`,
      signal: signal,
      headers: {
        userId: 1
      },
    })
    if (response && response.data && typeof response.data !== 'string') {
      groupList = response.data
    }
  }
  catch {

  }
  return groupList
}

export const getUsersGroup = async (userEmail, userId) => {
  let userList = [];
  let userInfo = getCurrentUserDetail();
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/groupsByEmail`
    })
    if (response && response.data && response.data.result) {
      userList = response.data
    }
  }
  catch {

  }
  return userList
}

export const getSpaceImages = async (spaceIds) => {
  let images = [];
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/spaceImages`,
      headers: {
        userId: 1,
      },
      params: {
        spaceIds: spaceIds.join("#")
      }
    })
    if (response && response.data && typeof response.data !== 'string') {
      images = response.data
    }
  }
  catch {

  }
  return images
}

export const getUserDetailsByEmail = async (email) => {
  let userDetail = {};
  if (!email) {
    return {}
  }
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/userDetails/${email}`,
      headers: {
        userId: 1,
      },
    })
    if (response && response.data && typeof response.data !== 'string') {
      userDetail = response.data
    }
  }
  catch {

  }
  return userDetail
}

export const uploadDocument = async (file, documentId) => {
  let docResponse = {}
  try {
    let response = await axios({
      method: "PUT",
      url: `${BACKEND_API}/upload/${documentId}`,
      headers: {
        userId: "1"
      }
    })
    if (response && response.data) {
      docResponse = response.data
    }
  }
  catch {

  }
  return docResponse

}
const formatErrorResponse = () => {
  let responseObj = {}
  responseObj.success = false;
  responseObj.message = "Failed to submit. Please try again"
  return responseObj
}
const formatSuccessResponse = (response) => {
  let responseObj = {}
  if (typeof response.data === "string") {
    responseObj.success = false;
    responseObj.message = response.data;
    responseObj.data = []
  } else {
    responseObj.success = true;
    responseObj.data = response.data;
  }
  return responseObj
}

// User services in Space
export async function addUserToSpace(data, userId) {
  
  let postData = { ...data }
  let userHubInfo = await getUserDetailsByEmail(data.email);
  if (userHubInfo.user) {
    postData.originalUserId = userHubInfo.user?.id;
    postData.name = userHubInfo.user?.name?.fullName
  }

  let responseObj = {}
  try {
    let response = await axios({
      method: "POST",
      url: `${BACKEND_API}/user`,
      data: { ...postData, tenantId: localStorage.getItem("tenantId") },
      headers: {
        userId: userId
      }
    })
    responseObj = formatSuccessResponse(response)
  } catch {
    responseObj.success = false;
    responseObj.message = "Failed to submit. Please try again"
  }
  return responseObj
}

export async function removeUserFromSpace(spaceId, userId, loggedInUserId) {
  let responseObj = {}, response = {}
  try {
    response = await axios({
      method: "DELETE",
      url: `${BACKEND_API}/user?userId=${userId}&spaceId=${spaceId}`,
      headers: {
        Accept: "application/json",
        userId: loggedInUserId,
        tenantId: tenantId
      },
    });
    responseObj = formatSuccessResponse(response)
    // TODO: user update is not happening, check
  } catch (error) {
    responseObj = formatErrorResponse(response)
  }
  return responseObj
}
// GROUPS SERVICES IN SPACE
export async function addGroupToSpace(data, userId) {
  

  let responseObj = {}
  try {
    let response = await axios({
      method: "POST",
      url: `${BACKEND_API}/group`,
      data: { ...data, tenantId: localStorage.getItem("tenantId") },
      headers: {
        userId: userId
      }
    })
    responseObj = formatSuccessResponse(response)
  } catch {
    responseObj.success = false;
    responseObj.message = "Failed to submit. Please try again"
  }
  return responseObj
}

export async function getGroupsInSpace(spaceId, userId) {
  let responseObj = {}
  try {
    let response = await axios({
      method: "get",
      url: `${BACKEND_API}/group`,
      params: {
        spaceId: spaceId,
      },
      headers: {
        userId: userId,
        tenantId: tenantId
      }
    })
    if (typeof response.data !== "string") {
      responseObj.data = response.data
      responseObj.message = true
    }
    // responseObj = formatSuccessResponse(response)
  } catch {
    responseObj.success = false;
    responseObj.message = ""
    responseObj.data = []
  }
  return responseObj
}

export async function removeGroupFromSpace(spaceId, groupId) {
  let responseObj = {}, response
  try {
    response = await axios({
      method: "DELETE",
      url: `${BACKEND_API}/group?groupId=${groupId}&spaceId=${spaceId}`
    });
    responseObj = formatSuccessResponse(response)
  } catch (error) {
    responseObj = formatErrorResponse(response)
  }
  return responseObj
}

export async function fetchGroupsSpaces(userGroups) {
  let responseObj = {}
  let encodedUserGroups = encodeTerm(userGroups);
  let url = `${BACKEND_API}/groups/details/${encodedUserGroups}?tenantId=1`;

  try {
    let response = await axios({
      method: "get",
      url: url,
      headers: {
        tenantId: tenantId
      }
    })
    responseObj = formatSuccessResponse(response)
  } catch {
    responseObj.success = false;
  }
  return responseObj
}

export async function getTenantGroups() {
  let responseObj = {}
  let tenantId = localStorage.getItem("tenantId")

  let url = `${BACKEND_API}/group/${tenantId}`;

  try {
    let response = await axios({
      method: "get",
      url: url,
      headers: {
        tenantId: tenantId
      }
    })
    responseObj = formatSuccessResponse(response)
  } catch {
    responseObj.success = false;
  }
  return responseObj
}

export async function getSpaceUsers(spaceId, userInfo) {
  let responseObj = {}

  let url = `${BACKEND_API}/users?spaceId=${spaceId}?tenantId=1`;

  try {
    let response = await axios({
      method: "get",
      url: url,
      headers: {
        userId: userInfo.userId,
        tenantId: tenantId
      }
    })
    responseObj = formatSuccessResponse(response)
  } catch {
    responseObj.success = false;
  }
  return responseObj
}

export async function getGroupUsers(groupId) {
  let responseObj = {}

  let url = `${BACKEND_API}/group/users/${groupId}`;

  try {
    let response = await axios({
      method: "get",
      url: url,
      headers: {
        // userId: userInfo.userId,
        tenantId: tenantId
      }
    })
    responseObj = formatSuccessResponse(response)
  } catch {
    responseObj.success = false;
  }
  return responseObj
}

export const uploadFile = async (file, requestId) => {
  let uploadResponse = {success: false}
  try {
    const formData = new FormData();
    formData.append('image', file); // Changed from 'image' to 'file' to match your curl

    let response = await axios({
      method: "POST",
      url: `${BACKEND_API}/upload/${requestId}`,
      data: formData,
      headers: {
        'tenantId': tenantId,
        'Authorization': '', // Add your authorization token here
        'X-Request-ID': '', // Add your request ID here if needed
        'requestTimeStamp': '', // Add timestamp if needed
        'Content-Type': 'multipart/form-data'
      }
    });
    if (response && response.data) {
      uploadResponse = {
        success: true,
        data: response.data,
        message: 'File uploaded successfully'
      };
    }
  } catch (error) {
    uploadResponse = {
      success: false,
      message: error.response?.data?.message || 'Failed to upload file',
      error: error
    };
  }
  return uploadResponse;
}

export const downloadFile = async (requestId, fileName) => {
  let downloadResponse = {}
  try {
    let response = await axios({
      method: "GET",
      url: `${BACKEND_API}/download/${requestId}/${fileName}`,
      headers: {
        'tenantId': tenantId,
        'Authorization': '', // Add your authorization token here
        'X-Request-ID': '', // Add your request ID here if needed
        'requestTimeStamp': '' // Add timestamp if needed
      }
      // Don't set responseType to 'blob' since API returns JSON with base64 content
    });
    
    if (response && response.data) {
      // Add success flag to match the expected structure in handlePreview
      downloadResponse = {
        ...response.data,
        success: true
      };
    }
  } catch (error) {
    downloadResponse = {
      success: false,
      message: error.response?.data?.message || 'Failed to download file',
      error: error
    };
  }
  return downloadResponse;
}

export const deleteFile = async (requestId, fileName) => {
  let deleteResponse = {}
  try {
    let response = await axios({
      method: "DELETE",
      url: `${BACKEND_API}/delete/${requestId}/${fileName}`,
      headers: {
        'tenantId': tenantId,
        'Authorization': '', // Add your authorization token here
        'X-Request-ID': '', // Add your request ID here if needed
        'requestTimeStamp': '' // Add timestamp if needed
      }
    });
    
    if (response && (response.status === 200 || response.status === 204)) {
      deleteResponse = {
        success: true,
        data: response.data,
        message: 'File deleted successfully'
      };
    }
  } catch (error) {
    deleteResponse = {
      success: false,
      message: error.response?.data?.message || 'Failed to delete file',
      error: error
    };
  }
  return deleteResponse;
}

export const getSearchResult = async (query) => {
  let result = {}
  let email = localStorage.getItem("userEmail")
  let url = `${BACKEND_API}/global-search?searchWord=${query}`;

  try {
    let response = await axios({
      method: "get",
      url: url,
    })
    result = formatSuccessResponse(response)
  } catch {
    result.success = false;
  }
  return result
} 